export default [
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "JJZ",
        "code": "Y9",
        "globalLongName": "JACUZZI BRANDS INC                      ",
        "cusip": "469865109",
        "shortName": "JJZ",
        "longName": "JACUZZI BRANDS, INC STOCK FUND",
        "quoteTickerSym": "JJZ  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "AIY9",
        "type": "S",
        "recordKeeperProductCode": "USIND",
        "fundGroupCd": "4",
        "fundGroupSeq": 4,
        "fundGroupName": "JOIN COMPANY STOCK                 ",
        "globalFundGroupCd": "4",
        "globalFundGroupSeq": 4,
        "globalFundGroupName": "COMPANY STOCK",
        "retailFundGroupCd": "RPSSTOCK",
        "vruPrompt": "C190",
        "objAprPrmNu": null,
        "taprodcd": "766",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": true,
        "marketBalanceExcluded": true,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": true,
        "mixExcluded": true,
        "loanExcluded": true,
        "redemptionExcluded": true,
        "fndMrkPrfExcluded": false,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 1.0,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.0,
        "changePercent": 0.0,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": false,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RK7",
        "code": "MD",
        "globalLongName": "Retirement 2045 Trust F                 ",
        "cusip": "872799887",
        "shortName": "RK7",
        "longName": "T ROWE PRICE RETIRE 2045 TR F",
        "quoteTickerSym": "RK7  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2MD",
        "type": "M",
        "recordKeeperProductCode": "1064 ",
        "fundGroupCd": "6",
        "fundGroupSeq": 6,
        "fundGroupName": "RETIREMENT",
        "globalFundGroupCd": "6",
        "globalFundGroupSeq": 6,
        "globalFundGroupName": "RETIREMENT",
        "retailFundGroupCd": null,
        "vruPrompt": "T724",
        "objAprPrmNu": null,
        "taprodcd": "2848",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 29.95,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.05,
        "changePercent": 0.0017,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": "retirement_active_trust",
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": true
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RG7",
        "code": "ME",
        "globalLongName": "Retirement 2025 Trust F                 ",
        "cusip": "872799507",
        "shortName": "RG7",
        "longName": "T ROWE PRICE RETIRE 2025 TR F",
        "quoteTickerSym": "RG7  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2ME",
        "type": "M",
        "recordKeeperProductCode": "1060 ",
        "fundGroupCd": "6",
        "fundGroupSeq": 6,
        "fundGroupName": "RETIREMENT",
        "globalFundGroupCd": "6",
        "globalFundGroupSeq": 6,
        "globalFundGroupName": "RETIREMENT",
        "retailFundGroupCd": null,
        "vruPrompt": "T720",
        "objAprPrmNu": null,
        "taprodcd": "4303",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 24.42,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": -0.02,
        "changePercent": -8.0E-4,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": "retirement_active_trust",
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": true
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RE7",
        "code": "MG",
        "globalLongName": "Retirement 2020 Trust F                 ",
        "cusip": "872799408",
        "shortName": "RE7",
        "longName": "T ROWE PRICE RETIRE 2020 TR F",
        "quoteTickerSym": "RE7  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2MG",
        "type": "M",
        "recordKeeperProductCode": "1059 ",
        "fundGroupCd": "6",
        "fundGroupSeq": 6,
        "fundGroupName": "RETIREMENT",
        "globalFundGroupCd": "6",
        "globalFundGroupSeq": 6,
        "globalFundGroupName": "RETIREMENT",
        "retailFundGroupCd": null,
        "vruPrompt": "T719",
        "objAprPrmNu": null,
        "taprodcd": "2646",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 22.53,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": -0.03,
        "changePercent": -0.0013,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": "retirement_active_trust",
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": true
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RD7",
        "code": "MH",
        "globalLongName": "Retirement 2015 Trust F                 ",
        "cusip": "872799309",
        "shortName": "RD7",
        "longName": "T ROWE PRICE RETIRE 2015 TR F",
        "quoteTickerSym": "RD7  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2MH",
        "type": "M",
        "recordKeeperProductCode": "1058 ",
        "fundGroupCd": "6",
        "fundGroupSeq": 6,
        "fundGroupName": "RETIREMENT",
        "globalFundGroupCd": "6",
        "globalFundGroupSeq": 6,
        "globalFundGroupName": "RETIREMENT",
        "retailFundGroupCd": null,
        "vruPrompt": "T718",
        "objAprPrmNu": null,
        "taprodcd": "2651",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 20.81,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": -0.03,
        "changePercent": -0.0014,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": "retirement_active_trust",
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": true
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RM7",
        "code": "MN",
        "globalLongName": "Retirement 2055 Trust F                 ",
        "cusip": "872799861",
        "shortName": "RM7",
        "longName": "T ROWE PRICE RETIRE 2055 TR F",
        "quoteTickerSym": "RM7  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2MN",
        "type": "M",
        "recordKeeperProductCode": "1066 ",
        "fundGroupCd": "6",
        "fundGroupSeq": 6,
        "fundGroupName": "RETIREMENT",
        "globalFundGroupCd": "6",
        "globalFundGroupSeq": 6,
        "globalFundGroupName": "RETIREMENT",
        "retailFundGroupCd": null,
        "vruPrompt": "T726",
        "objAprPrmNu": null,
        "taprodcd": "2690",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 29.97,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.05,
        "changePercent": 0.0017,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": "retirement_active_trust",
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": true
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "IPI",
        "code": "4U",
        "globalLongName": "INFLATION PROTECTED BOND - I CL         ",
        "cusip": "77958D200",
        "shortName": "IPI",
        "longName": "T ROWE PRICE INFL PROT BD I",
        "quoteTickerSym": "TIIPX",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X24U",
        "type": "M",
        "recordKeeperProductCode": "439  ",
        "fundGroupCd": "2",
        "fundGroupSeq": 2,
        "fundGroupName": "JOIN BONDS                         ",
        "globalFundGroupCd": "2",
        "globalFundGroupSeq": 2,
        "globalFundGroupName": "BONDS",
        "retailFundGroupCd": null,
        "vruPrompt": "S648",
        "objAprPrmNu": null,
        "taprodcd": "6206",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": true,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 10.44,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": -0.05,
        "changePercent": -0.0048,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": "Investment Grade Bond              ",
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RB7",
        "code": "MP",
        "globalLongName": "Retirement 2005 Trust F                 ",
        "cusip": "872799101",
        "shortName": "RB7",
        "longName": "T ROWE PRICE RETIRE 2005 TR F",
        "quoteTickerSym": "RB7  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2MP",
        "type": "M",
        "recordKeeperProductCode": "1056 ",
        "fundGroupCd": "6",
        "fundGroupSeq": 6,
        "fundGroupName": "RETIREMENT",
        "globalFundGroupCd": "6",
        "globalFundGroupSeq": 6,
        "globalFundGroupName": "RETIREMENT",
        "retailFundGroupCd": "COMTRUST",
        "vruPrompt": "T716",
        "objAprPrmNu": null,
        "taprodcd": "2661",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 18.01,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": -0.04,
        "changePercent": -0.0022,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": "retirement_active_trust",
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": true,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": true
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RN7",
        "code": "MR",
        "globalLongName": "Retirement 2060 Trust F                 ",
        "cusip": "872799853",
        "shortName": "RN7",
        "longName": "T ROWE PRICE RETIRE 2060 TR F",
        "quoteTickerSym": "RN7  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2MR",
        "type": "M",
        "recordKeeperProductCode": "1067 ",
        "fundGroupCd": "6",
        "fundGroupSeq": 6,
        "fundGroupName": "RETIREMENT",
        "globalFundGroupCd": "6",
        "globalFundGroupSeq": 6,
        "globalFundGroupName": "RETIREMENT",
        "retailFundGroupCd": null,
        "vruPrompt": "T727",
        "objAprPrmNu": null,
        "taprodcd": "2876",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 19.17,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.03,
        "changePercent": 0.0016,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": "retirement_active_trust",
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": true
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RL7",
        "code": "MV",
        "globalLongName": "Retirement 2050 Trust F                 ",
        "cusip": "872799879",
        "shortName": "RL7",
        "longName": "T ROWE PRICE RETIRE 2050 TR F",
        "quoteTickerSym": "RL7  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2MV",
        "type": "M",
        "recordKeeperProductCode": "1065 ",
        "fundGroupCd": "6",
        "fundGroupSeq": 6,
        "fundGroupName": "RETIREMENT",
        "globalFundGroupCd": "6",
        "globalFundGroupSeq": 6,
        "globalFundGroupName": "RETIREMENT",
        "retailFundGroupCd": null,
        "vruPrompt": "T725",
        "objAprPrmNu": null,
        "taprodcd": "2758",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 30.0,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.05,
        "changePercent": 0.0017,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": "retirement_active_trust",
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": true
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RA7",
        "code": "MY",
        "globalLongName": "Retirement Balanced Trust F             ",
        "cusip": "872799846",
        "shortName": "RA7",
        "longName": "T ROWE PRICE RETIRE BAL TR F",
        "quoteTickerSym": "RA7  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2MY",
        "type": "M",
        "recordKeeperProductCode": "1068 ",
        "fundGroupCd": "6",
        "fundGroupSeq": 6,
        "fundGroupName": "RETIREMENT",
        "globalFundGroupCd": "6",
        "globalFundGroupSeq": 6,
        "globalFundGroupName": "RETIREMENT",
        "retailFundGroupCd": null,
        "vruPrompt": "T715",
        "objAprPrmNu": null,
        "taprodcd": "2647",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 17.63,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": -0.04,
        "changePercent": -0.0023,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": "retirement_active_trust",
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": true
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "VTSNX",
        "code": "VJ",
        "globalLongName": "VANGUARD TOT I STK;INS                  ",
        "cusip": "921909784",
        "shortName": "VTSNX",
        "longName": "VANGUARD TTL INTL STK IDX INST",
        "quoteTickerSym": "VTSNX",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "ABVJ",
        "type": "B",
        "recordKeeperProductCode": "VTSNX",
        "fundGroupCd": "3",
        "fundGroupSeq": 3,
        "fundGroupName": "JOIN STOCKS                        ",
        "globalFundGroupCd": "3",
        "globalFundGroupSeq": 1,
        "globalFundGroupName": "STOCKS",
        "retailFundGroupCd": "MUTFUND",
        "vruPrompt": "L815",
        "objAprPrmNu": null,
        "taprodcd": "2946",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": true,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 114.65,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.61,
        "changePercent": 0.0053,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": "Foreign Large Blend           ",
        "trpCategoryName": "International Stock                ",
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "VRSF",
        "code": "B7",
        "globalLongName": "VANGUARD RETIREMENT SAVINGS TR          ",
        "cusip": "92202V500",
        "shortName": "VRSF",
        "longName": "VANGUARD RET SAVINGS TRUST III",
        "quoteTickerSym": "VRSF ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2B7",
        "type": "M",
        "recordKeeperProductCode": "VRSF ",
        "fundGroupCd": "5",
        "fundGroupSeq": 5,
        "fundGroupName": "OTHER                              ",
        "globalFundGroupCd": "1",
        "globalFundGroupSeq": 3,
        "globalFundGroupName": "MONEY MARKET/ STABLE VALUE",
        "retailFundGroupCd": null,
        "vruPrompt": "W054",
        "objAprPrmNu": null,
        "taprodcd": "3182",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": false,
        "marketBalanceExcluded": false,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": true,
        "mixExcluded": true,
        "loanExcluded": false,
        "redemptionExcluded": false,
        "fndMrkPrfExcluded": false,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 1.0,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.0,
        "changePercent": 0.0,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": false,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "VIEIX",
        "code": "5K",
        "globalLongName": "VANGUARD EXT MARKET INDEX INST          ",
        "cusip": "922908884",
        "shortName": "VIEIX",
        "longName": "VANGUARD EXT MARKET INDEX INST",
        "quoteTickerSym": "VIEIX",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "AB5K",
        "type": "M",
        "recordKeeperProductCode": "VIEIX",
        "fundGroupCd": "3",
        "fundGroupSeq": 3,
        "fundGroupName": "JOIN STOCKS                        ",
        "globalFundGroupCd": "3",
        "globalFundGroupSeq": 1,
        "globalFundGroupName": "STOCKS",
        "retailFundGroupCd": "MUTFUND",
        "vruPrompt": "H931",
        "objAprPrmNu": null,
        "taprodcd": "1965",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": true,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 107.8,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 1.78,
        "changePercent": 0.0168,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": "Mid-Cap Blend                 ",
        "trpCategoryName": "Mid Cap Stock                      ",
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "MCI",
        "code": "O3",
        "globalLongName": "MID-CAP GROWTH - I CL                   ",
        "cusip": "779556406",
        "shortName": "MCI",
        "longName": "T ROWE PRICE MID CAP GRWTH I",
        "quoteTickerSym": "RPTIX",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "BWO3",
        "type": "M",
        "recordKeeperProductCode": "524  ",
        "fundGroupCd": "3",
        "fundGroupSeq": 3,
        "fundGroupName": "JOIN STOCKS                        ",
        "globalFundGroupCd": "3",
        "globalFundGroupSeq": 1,
        "globalFundGroupName": "STOCKS",
        "retailFundGroupCd": null,
        "vruPrompt": "R340",
        "objAprPrmNu": null,
        "taprodcd": "5496",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 96.89,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.46,
        "changePercent": 0.0048,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": "Mid Cap Stock                      ",
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "GSI",
        "code": "O4",
        "globalLongName": "GROWTH STOCK - I CL                     ",
        "cusip": "741479406",
        "shortName": "GSI",
        "longName": "T ROWE PRICE GROWTH STOCK I",
        "quoteTickerSym": "PRUFX",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "BVO4",
        "type": "M",
        "recordKeeperProductCode": "540  ",
        "fundGroupCd": "3",
        "fundGroupSeq": 3,
        "fundGroupName": "JOIN STOCKS                        ",
        "globalFundGroupCd": "3",
        "globalFundGroupSeq": 1,
        "globalFundGroupName": "STOCKS",
        "retailFundGroupCd": null,
        "vruPrompt": "R355",
        "objAprPrmNu": null,
        "taprodcd": "5495",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": true,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 82.6,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": -0.23,
        "changePercent": -0.0028,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": "Large Cap Stock                    ",
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "VBTIX",
        "code": "1Z",
        "globalLongName": "VANGUARD TOTAL BOND; INS                ",
        "cusip": "921937504",
        "shortName": "VBTIX",
        "longName": "VANGUARD TTL BND MRK INDX INST",
        "quoteTickerSym": "VBTIX",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "AA1Z",
        "type": "M",
        "recordKeeperProductCode": "VBII ",
        "fundGroupCd": "2",
        "fundGroupSeq": 2,
        "fundGroupName": "JOIN BONDS                         ",
        "globalFundGroupCd": "2",
        "globalFundGroupSeq": 2,
        "globalFundGroupName": "BONDS",
        "retailFundGroupCd": "MUTFUND",
        "vruPrompt": "5700",
        "objAprPrmNu": null,
        "taprodcd": "400",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": true,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 9.1,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": -0.05,
        "changePercent": -0.0055,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": "Intermediate-Term Bond        ",
        "trpCategoryName": "Investment Grade Bond              ",
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "DFFVX",
        "code": "SF",
        "globalLongName": "DFA U.S. TARGETED VALUE I               ",
        "cusip": "233203595",
        "shortName": "DFFVX",
        "longName": "DFA U.S. TARGETED VALUE I",
        "quoteTickerSym": "DFFVX",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "AFSF",
        "type": "M",
        "recordKeeperProductCode": "DFFVX",
        "fundGroupCd": "3",
        "fundGroupSeq": 3,
        "fundGroupName": "JOIN STOCKS                        ",
        "globalFundGroupCd": "3",
        "globalFundGroupSeq": 1,
        "globalFundGroupName": "STOCKS",
        "retailFundGroupCd": "MUTFUND",
        "vruPrompt": "I267",
        "objAprPrmNu": null,
        "taprodcd": "2036",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 27.78,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.44,
        "changePercent": 0.0161,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": "Small Value                   ",
        "trpCategoryName": "Small Cap Stock                    ",
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "JCPUX",
        "code": "BY",
        "globalLongName": "JPMORGAN:CORE PL BD;R6                  ",
        "cusip": "4812C0134",
        "shortName": "JCPUX",
        "longName": "JPMORGAN CORE PLUS BOND R6",
        "quoteTickerSym": "JCPUX",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "BYBY",
        "type": "M",
        "recordKeeperProductCode": "JCPUX",
        "fundGroupCd": "2",
        "fundGroupSeq": 2,
        "fundGroupName": "JOIN BONDS                         ",
        "globalFundGroupCd": "2",
        "globalFundGroupSeq": 2,
        "globalFundGroupName": "BONDS",
        "retailFundGroupCd": null,
        "vruPrompt": "Q123",
        "objAprPrmNu": null,
        "taprodcd": "5033",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": true,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 6.82,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": -0.04,
        "changePercent": -0.0058,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": "Intermediate-Term Bond        ",
        "trpCategoryName": "Investment Grade Bond              ",
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RI7",
        "code": "KB",
        "globalLongName": "Retirement 2035 Trust F                 ",
        "cusip": "872799705",
        "shortName": "RI7",
        "longName": "T ROWE PRICE RETIRE 2035 TR F",
        "quoteTickerSym": "RI7  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2KB",
        "type": "M",
        "recordKeeperProductCode": "1062 ",
        "fundGroupCd": "6",
        "fundGroupSeq": 6,
        "fundGroupName": "RETIREMENT",
        "globalFundGroupCd": "6",
        "globalFundGroupSeq": 6,
        "globalFundGroupName": "RETIREMENT",
        "retailFundGroupCd": null,
        "vruPrompt": "T722",
        "objAprPrmNu": null,
        "taprodcd": "5216",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 27.92,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.01,
        "changePercent": 4.0E-4,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": "retirement_active_trust",
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": true
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RJ7",
        "code": "KC",
        "globalLongName": "Retirement 2040 Trust F                 ",
        "cusip": "872799804",
        "shortName": "RJ7",
        "longName": "T ROWE PRICE RETIRE 2040 TR F",
        "quoteTickerSym": "RJ7  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2KC",
        "type": "M",
        "recordKeeperProductCode": "1063 ",
        "fundGroupCd": "6",
        "fundGroupSeq": 6,
        "fundGroupName": "RETIREMENT",
        "globalFundGroupCd": "6",
        "globalFundGroupSeq": 6,
        "globalFundGroupName": "RETIREMENT",
        "retailFundGroupCd": null,
        "vruPrompt": "T723",
        "objAprPrmNu": null,
        "taprodcd": "5217",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 29.28,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.03,
        "changePercent": 0.001,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": "retirement_active_trust",
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": true
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "GSELX",
        "code": "KG",
        "globalLongName": "GOLDMAN SACHS STRUCT US EQ, I           ",
        "cusip": "38141W372",
        "shortName": "GSELX",
        "longName": "GOLDMAN SACHS STRUCT US EQ, I",
        "quoteTickerSym": "GSELX",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "ABKG",
        "type": "M",
        "recordKeeperProductCode": "GSELX",
        "fundGroupCd": "3",
        "fundGroupSeq": 3,
        "fundGroupName": "JOIN STOCKS                        ",
        "globalFundGroupCd": "3",
        "globalFundGroupSeq": 1,
        "globalFundGroupName": "STOCKS",
        "retailFundGroupCd": "MUTFUND",
        "vruPrompt": "G898",
        "objAprPrmNu": null,
        "taprodcd": "1737",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": true,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 1.0,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.0,
        "changePercent": 0.0,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": "Large Blend                   ",
        "trpCategoryName": "Large Cap Stock                    ",
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "HWDYX",
        "code": "KK",
        "globalLongName": "HARTFD:WORLD BOND;Y                     ",
        "cusip": "41664M185",
        "shortName": "HWDYX",
        "longName": "HARTFORD WORLD BOND Y",
        "quoteTickerSym": "HWDYX",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2KK",
        "type": "M",
        "recordKeeperProductCode": "HWDYX",
        "fundGroupCd": "2",
        "fundGroupSeq": 2,
        "fundGroupName": "JOIN BONDS                         ",
        "globalFundGroupCd": "2",
        "globalFundGroupSeq": 2,
        "globalFundGroupName": "BONDS",
        "retailFundGroupCd": null,
        "vruPrompt": "T519",
        "objAprPrmNu": null,
        "taprodcd": "5774",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 9.71,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": -0.01,
        "changePercent": -0.001,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": "World Bond                    ",
        "trpCategoryName": "International Bond                 ",
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "VIIT",
        "code": "P3",
        "globalLongName": "VANGUARD INSTITUIONAL INDEX             ",
        "cusip": "922040100",
        "shortName": "VIIT",
        "longName": "VANGUARD INST INDEX",
        "quoteTickerSym": "VINIX",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "AAP3",
        "type": "M",
        "recordKeeperProductCode": "VIIT ",
        "fundGroupCd": "3",
        "fundGroupSeq": 3,
        "fundGroupName": "JOIN STOCKS                        ",
        "globalFundGroupCd": "3",
        "globalFundGroupSeq": 1,
        "globalFundGroupName": "STOCKS",
        "retailFundGroupCd": "MUTFUND",
        "vruPrompt": "5115",
        "objAprPrmNu": null,
        "taprodcd": "405",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": true,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 365.28,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 3.84,
        "changePercent": 0.0106,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": "Large Blend                   ",
        "trpCategoryName": "Large Cap Stock                    ",
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RH7",
        "code": "KS",
        "globalLongName": "Retirement 2030 Trust F                 ",
        "cusip": "872799606",
        "shortName": "RH7",
        "longName": "T ROWE PRICE RETIRE 2030 TR F",
        "quoteTickerSym": "RH7  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2KS",
        "type": "M",
        "recordKeeperProductCode": "1061 ",
        "fundGroupCd": "6",
        "fundGroupSeq": 6,
        "fundGroupName": "RETIREMENT",
        "globalFundGroupCd": "6",
        "globalFundGroupSeq": 6,
        "globalFundGroupName": "RETIREMENT",
        "retailFundGroupCd": null,
        "vruPrompt": "T721",
        "objAprPrmNu": null,
        "taprodcd": "2624",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 26.25,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": -0.01,
        "changePercent": -4.0E-4,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": "retirement_active_trust",
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": true
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RC7",
        "code": "KT",
        "globalLongName": "Retirement 2010 Trust F                 ",
        "cusip": "872799200",
        "shortName": "RC7",
        "longName": "T ROWE PRICE RETIRE 2010 TR F",
        "quoteTickerSym": "RC7  ",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "X2KT",
        "type": "M",
        "recordKeeperProductCode": "1057 ",
        "fundGroupCd": "6",
        "fundGroupSeq": 6,
        "fundGroupName": "RETIREMENT",
        "globalFundGroupCd": "6",
        "globalFundGroupSeq": 6,
        "globalFundGroupName": "RETIREMENT",
        "retailFundGroupCd": null,
        "vruPrompt": "T717",
        "objAprPrmNu": null,
        "taprodcd": "2738",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 19.12,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": -0.03,
        "changePercent": -0.0016,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": "retirement_active_trust",
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": true
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "RERGX",
        "code": "L8",
        "globalLongName": "AMERICAN FUNDS EUPC;R-6                 ",
        "cusip": "298706821",
        "shortName": "RERGX",
        "longName": "AMERICAN FUNDS EUROPAC GRW R6",
        "quoteTickerSym": "RERGX",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "ABL8",
        "type": "M",
        "recordKeeperProductCode": "RERGX",
        "fundGroupCd": "3",
        "fundGroupSeq": 3,
        "fundGroupName": "JOIN STOCKS                        ",
        "globalFundGroupCd": "3",
        "globalFundGroupSeq": 1,
        "globalFundGroupName": "STOCKS",
        "retailFundGroupCd": "MUTFUND",
        "vruPrompt": "1737",
        "objAprPrmNu": null,
        "taprodcd": "2601",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": true,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 51.62,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.26,
        "changePercent": 0.0051,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": "Foreign Large Blend           ",
        "trpCategoryName": "International Stock                ",
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "TSVN",
        "code": "PE",
        "globalLongName": "STABLE VALUE FUND                       ",
        "cusip": "741485601",
        "shortName": "TSVN",
        "longName": "TRP STABLE VALUE FUND - N",
        "quoteTickerSym": "SVF-N",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "ABPE",
        "type": "M",
        "recordKeeperProductCode": "460  ",
        "fundGroupCd": "1",
        "fundGroupSeq": 1,
        "fundGroupName": "JOIN MONEY MARKET/ STABLE VALUE    ",
        "globalFundGroupCd": "1",
        "globalFundGroupSeq": 3,
        "globalFundGroupName": "MONEY MARKET/ STABLE VALUE",
        "retailFundGroupCd": "COMTRUST",
        "vruPrompt": "H161",
        "objAprPrmNu": null,
        "taprodcd": "1769",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": false,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 1.0,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.0,
        "changePercent": 0.0,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PRIVATE",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": null,
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": true,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    },
    {
        "consumerName": null,
        "uniqueKey": null,
        "planNum": "805222",
        "sequence": 0,
        "abbrev": "VAI",
        "code": "Y7",
        "globalLongName": "VALUE - I CL                            ",
        "cusip": "779578301",
        "shortName": "VAI",
        "longName": "T ROWE PRICE VALUE I",
        "quoteTickerSym": "TRPIX",
        "fundSourceType": "F",
        "rpsInvestVehicleNum": "CLY7",
        "type": "M",
        "recordKeeperProductCode": "523  ",
        "fundGroupCd": "3",
        "fundGroupSeq": 3,
        "fundGroupName": "JOIN STOCKS                        ",
        "globalFundGroupCd": "3",
        "globalFundGroupSeq": 1,
        "globalFundGroupName": "STOCKS",
        "retailFundGroupCd": null,
        "vruPrompt": "R799",
        "objAprPrmNu": null,
        "taprodcd": "5701",
        "conformingFund": true,
        "nonConformingCode": " ",
        "settleDelayDays": 0,
        "inKindDisbursmentCode": " ",
        "trackedForExcessiveTrading": true,
        "txnUnit": null,
        "tradeDateXCPInd": null,
        "vestedBalanceExcluded": null,
        "marketBalanceExcluded": null,
        "selfDirectedAccountExcluded": null,
        "exchangeToExcluded": null,
        "mixExcluded": null,
        "loanExcluded": null,
        "redemptionExcluded": null,
        "fndMrkPrfExcluded": null,
        "productMaxAllowedPercent": 1.0,
        "productMinAllowedPercent": 0.0,
        "productMixIncrement": 0.0,
        "descriptionAvailable": true,
        "currentPrice": 39.89,
        "priceAsOfDate": "2023-10-17T04:00:00.000+00:00",
        "changeDollars": 0.18,
        "changePercent": 0.0045,
        "prc52WkLowAm": 0.0,
        "prc52WkHigAm": 0.0,
        "exchangeToMaxPct": 0.0,
        "markRestriction": false,
        "fundType": "E",
        "minOpeningBalance": null,
        "quoteTickerType": "PUBLIC",
        "glidePathInvestmentType": null,
        "esopPlanFundElgDivDflNu": null,
        "esopDivDtDivDflNu": null,
        "externalProducts": null,
        "morningStarCategoryName": null,
        "trpCategoryName": "Large Cap Stock                    ",
        "troweProduct": null,
        "withDrawalRestricted": null,
        "companyStock": null,
        "rclass": null,
        "iclass": null,
        "advisorClass": null,
        "nonCore": false,
        "isTrust": false,
        "isFrozen": null,
        "isMPI": false,
        "isValidCusip": true,
        "isRDF": false
    }
]